// extracted by mini-css-extract-plugin
module.exports = {"root":"PageNotFound_root___SSSQ","label":"PageNotFound_label__Em0vv","text":"PageNotFound_text__9epzj","actions":"PageNotFound_actions__HBH9t","img":"PageNotFound_img__pJVLj"};